module.exports = "body {\n  background-color: #f3f3f3 !important; }\n\n.common-img-bg {\n  background: #ffffff !important; }\n\n.loginlogo {\n  width: 58%; }\n\n@media only screen and (max-width: 992px) {\n  .loginlogo {\n    height: 30%;\n    width: 50%; } }\n\n@media only screen and (max-width: 758px) {\n  .loginlogo {\n    height: 10%;\n    width: 30%; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-forget-password/master-forget-password.component.scss
// module id = ./src/app/master/master-forget-password/master-forget-password.component.scss
// module chunks = main